<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <div class="content inner-scroll" style="overflow: auto; -webkit-overflow-scrolling: touch; width: 230px;">


        <div class="row">

        </div>

    </div>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center" style="margin-left: 5px;">
        <div class="col-md-12 text-left">
            <div *ngIf="processing"> {{'Processing'|translate}}... </div>
            <div *ngIf="error.length>0" style="color:red;">{{error}}</div>

            <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
                <mat-button-toggle
                        mwlCalendarPreviousView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()"
                >
                    {{'Previous month'|translate}}</mat-button-toggle>
                <mat-button-toggle
                        mwlCalendarToday
                        [(viewDate)]="viewDate"
                >
                    {{'Current month' | translate}}
                </mat-button-toggle>
                <mat-button-toggle
                        mwlCalendarNextView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()"
                >
                    {{'Next month'|translate}}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <div class="content-card scroll-container" style="overflow: auto; -webkit-overflow-scrolling: touch;"
             #scrollContainer>

            <div class="row">
                <mwl-calendar-month-view
                        [viewDate]="viewDate"
                        [events]="events"
                        [activeDayIsOpen]="true"
                        (dayClicked)="sectionClicked($event)"
                        (eventClicked)="eventClicked($event)"
                        (eventTimesChanged)="eventTimesChanged($event)"
                ></mwl-calendar-month-view>
            </div>
        </div>
    </div>
</div>
